
    <div class="treasure-window">
      <div class="overflow-content">
        <div *ngFor="let row of rows; let rowIndex = index" class="row">
          <div class="row-label">{{ rowsLength - rowIndex }}</div>
          <app-treasure-reply-item
            *ngFor="let col of columns; let columnIndex = index"
            [openCase]="luckyNumbers[rowIndex][columnIndex]"
            [row]="rowsLength - rowIndex - 1"
          ></app-treasure-reply-item>
        </div>
      </div>
    </div>
  


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/components/reply/reply-treasure/reply-treasure-hunt.component.ts.ReplyTreasureHuntComponent.html